import * as React from "react";
import {
  renderMenuPopover_unstable,
  useMenuPopover_unstable,
} from "@fluentui/react-components";
import { useAppMenuPopoverStyles } from "./useAppMenuPopoverStyles";
import type { AppMenuPopoverProps } from "./AppMenuPopover.types";

export const AppMenuPopover = React.forwardRef<
  HTMLDivElement,
  AppMenuPopoverProps
>((props, ref) => {
  const state = useMenuPopover_unstable(props, ref);
  useAppMenuPopoverStyles(state, props.isRightClickMenu, props.ribbonMode);
  return renderMenuPopover_unstable(state);
});

AppMenuPopover.displayName = "next/AppMenuPopover";
